import React, { useContext } from 'react';
import { useTheme } from '../context/ThemeContext'; // ✅ adjust path if needed
import './ThemeSelector.css'; // optional custom styles

const ThemeSelector = () => {
  const { theme, toggleTheme, setTheme } = useTheme();

  const handleThemeChange = async (e) => {
    const selectedTheme = e.target.value;
    setTheme(selectedTheme);
    localStorage.setItem('theme', selectedTheme);

    // Update body theme
    if (selectedTheme === 'auto') {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.body.setAttribute('data-theme', systemPrefersDark ? 'dark' : 'light');
    } else {
      document.body.setAttribute('data-theme', selectedTheme);
    }

    // Save to backend
    try {
      const res = await fetch('/api/user/theme', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: 'default-user', // this will be dynamic in future
          theme: selectedTheme,
        }),
      });

      const data = await res.json();
      console.log('[Theme Saved]', data);
    } catch (err) {
      console.error('Failed to save theme:', err);
    }
  };

  return (
    <div className="theme-selector">
      <label htmlFor="theme-select">Theme:</label>
      <select id="theme-select" value={theme} onChange={handleThemeChange}>
        <option value="light">🌞 Light</option>
        <option value="dark">🌙 Dark</option>
        <option value="auto">⚙️ Auto</option>
      </select>
    </div>
  );
};

export default ThemeSelector;

